export const historiaWersji = 
[
    {
        data: "2021-07-27",
        wersja: "2.2.7",
        opis: "poprawka działania strony dla grafiku wirtualnego (strona nie działała), wyrzucenie ramek z grafiku i nawigacji, poprawka minimalnej daty przy zmienianiu pobytu",
        ktoZrobil: "pm"
    },
    {
        data: "2021-07-12",
        wersja: "2.2.6",
        opis: "poprawki grafików, lewy panel: zmiana przycisków i czcionki, grafik numerami: scrollowanie grafika po klinięciu grafik w panelu pokoju, panele z pokojami: wyrzucenie \"Ilość osób min\", przerzucenie wszystkich poprzednich opisów do \"info\"",
        ktoZrobil: "szw pm"
    },
    {
        data: "2021-07-09",
        wersja: "2.2.5",
        opis: "poprawki paneli pokoi",
        ktoZrobil: "szw"
    },
    {
        data: "2021-07-08",
        wersja: "2.2.4",
        opis: "podłączenie zdjęc, dodanie logiki dla 3 różnych grafików, naprawa starej rezerwacji, otwarcie aplikacji z linku",
        ktoZrobil: "pm szw"
    },
    {
        data: "2021-07-06",
        wersja: "2.2.3",
        opis: "dodanie pokojów numerami pod grafikiem",
        ktoZrobil: "pm"
    },
    {
        data: "2021-07-05",
        wersja: "2.2.2",
        opis: "pomniejsze zmiany",
        ktoZrobil: "szw"
    },
    {
        data: "2021-07-01",
        wersja: "2.2.1",
        opis: "poprawki grafików i panelu pokoi",
        ktoZrobil: "szw"
    },
    {
        data: "2021-06-29",
        wersja: "2.2.0",
        opis: "zamiana serwisów na obiektowe",
        ktoZrobil: "szw"
    },
    {
        data: "2021-06-23",
        wersja: "2.1.9",
        opis: "uruchomienie grafików, poprawki grafików",
        ktoZrobil: "szw"
    },
    {
        data: "2021-06-22",
        wersja: "2.1.8",
        opis: "dodanie grafików na podobieństwo bookuj",
        ktoZrobil: "szw"
    },
    {
        data: "2021-06-17",
        wersja: "2.1.7",
        opis: "poprawa bibliotek, poprawa borderu tabeli",
        ktoZrobil: "szw"
    },
    {
        data: "2021-04-28",
        wersja: "2.1.6",
        opis: "zmiana liczby dni i proporcji w grafiku",
        ktoZrobil: "pm"
    },
    {
        data: "2021-04-27",
        wersja: "2.1.5",
        opis: "mniejsze zmiany wyglądu strony głównej, poprawa wyglądu przycisków, poprawka borderu dzisiaj",
        ktoZrobil: "szw"
    },
    {
        data: "2021-04-26",
        wersja: "2.1.4",
        opis: "wyrzucenie borderów paneli strony głównej, zmniejszenie grafika, poprawka grafika",
        ktoZrobil: "szw"
    },
    {
        data: "2021-03-18",
        wersja: "2.1.3",
        opis: "przeróbka wyglądu lewego i prawego panelu",
        ktoZrobil: "pm"
    },
    {
        data: "2021-02-18",
        wersja: "2.1.2",
        opis: "dodanie anulowania i zmiany rezerwacji, przerzucenie ikon Google do panelu kontakt z nami, zmniejszenie czcionki w oknie szczegóły, zmiania czcionki tytułu w karcie z pokojem na bold, zmiana czcionki w oknie z nawigacją na fioletową",
        ktoZrobil: "pm"
    },
    {
        data: "2021-02-12",
        wersja: "2.1.1",
        opis: "przeróbka wyglądu formularza",
        ktoZrobil: "pm"
    },
    {
        data: "2021-01-04",
        wersja: "2.1.0",
        opis: "zmiana wyglądu głównego okna",
        ktoZrobil: "szw"
    },
    {
        data: "2020-12-17",
        wersja: "2.0.9",
        opis: "poprawka błędów w prawym panelu i w formularzu",
        ktoZrobil: "pm"
    },
    {
        data: "2020-12-11",
        wersja: "2.0.8",
        opis: "dodanie okna braku połączenia z serwerem",
        ktoZrobil: "szw"
    },
    {
        data: "2020-11-19",
        wersja: "2.0.7",
        opis: "obcięcie opisu pokoju na panelu do jednej lini",
        ktoZrobil: "pm"
    },
    {
        data: "2020-11-05",
        wersja: "2.0.6",
        opis: "poprawa komunikatu o niepowodzeniu przy płatności internetowej",
        ktoZrobil: "pm"
    },
    {
        data: "2020-11-03",
        wersja: "2.0.5",
        opis: "dodano okno potwierdzające anulację rezerwacji",
        ktoZrobil: "szw"
    },
    {
        data: "2020-10-22",
        wersja: "2.0.4",
        opis: "zmiana opisu przycisku w formularzu rezerwacyjnym z \"dalej\" na \"rezerwuj\"",
        ktoZrobil: "pm"
    },
    {
        data: "2020-10-21",
        wersja: "2.0.3",
        opis: "poprawa kalendarza",
        ktoZrobil: "szw"
    },
    {
        data: "2020-10-20",
        wersja: "2.0.2",
        opis: "dodano możliwość anulowania rezerwacji",
        ktoZrobil: "szw"
    },
    {
        data: "2020-10-14",
        wersja: "2.0.1",
        opis: "poprawa, optymalizacja części kodu, naprawa błędów",
        ktoZrobil: "szw"
    },
    {
        data: "2020-09-25",
        wersja: "2.0.0",
        opis: "dodano okno wersja",
        ktoZrobil: "pm szw"
    },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.1",
    //     opis: "dodano okno wersja, poprawa wyglądu strony"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.11",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.11.11",
    //     opis: "dodano okno wersja, opis w tej komórce jest bardzo długi"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // },
    // {
    //     data: "2020-09-24",
    //     wersja: "2.1.0",
    //     opis: "dodano okno wersja"
    // }
]